/** @format */

export enum DataLayerEventType {
    USER_LOADED = 'USER_LOADED',
    LOGOUT = 'LOGOUT',
    LOGIN = 'LOGIN',
    PURCHASE = 'PURCHASE',
    PAYMENT_LINK_COMPLETE = 'PAYMENT_LINK_COMPLETE',
    ADD_TO_BASKET = 'ADD_TO_BASKET',
    SEARCH_RESULTS = 'SEARCH_RESULTS',
    BOOKING_IN_COMPLETE = 'BOOKING_IN_COMPLETE',
    PRODUCT_PAGE_VIEW = 'PRODUCT_PAGE_VIEW',
    MODEL_PAGE_VIEW = 'MODEL_PAGE_VIEW',
    MODEL_RECOMMENDATIONS_CAROUSEL = 'MODEL_RECOMMENDATIONS_CAROUSEL',
    EXPERIMENT = 'MPB_Experiment',
    HOME_PAGE_VIEW = 'HOME_PAGE_VIEW',
}

export enum DataLayerPromotionEventType {
    PROMO_ADDED_TO_QUOTE = 'PROMO_ADDED_TO_QUOTE',
    PROMO_APPLIED_ON_INPUT = 'PROMO_APPLIED_ON_INPUT',
    PROMO_ADDED_ON_CHECKOUT_SUBMIT = 'PROMO_ADDED_ON_CHECKOUT_SUBMIT',
}

export enum DataLayerCheckoutEventType {
    PAYMENT_GATEWAYS_REQUESTED = 'CHECKOUT_PAYMENT_GATEWAYS_REQUESTED',
    PAYMENT_GATEWAYS = 'CHECKOUT_PAYMENT_GATEWAYS',
    PAYMENT_TOKEN_REQUESTED = 'CHECKOUT_PAYMENT_TOKEN_REQUESTED',
    PAYMENT_TOKEN = 'CHECKOUT_PAYMENT_TOKEN',
    PAYMENT_TOKEN_ERROR = 'CHECKOUT_PAYMENT_TOKEN_ERROR',
    STRIPE_ELEMENTS_LOADED = 'CHECKOUT_STRIPE_ELEMENTS_LOADED',
    STRIPE_ELEMENTS_LOAD_ERROR = 'CHECKOUT_STRIPE_ELEMENTS_LOAD_ERROR',
    PAYMENT_OPTION_SELECTED = 'CHECKOUT_PAYMENT_OPTION_SELECTED',
    PAYMENT_OPTION_VALID = 'CHECKOUT_PAYMENT_OPTION_VALID',
    CHECKOUT_CREATED = 'CHECKOUT_CREATED',
    CHECKOUT_STARTED = 'CHECKOUT_STARTED',
    CONFIRM_PAYMENT = 'CHECKOUT_CONFIRM_PAYMENT',
    PAYMENT_ERROR = 'CHECKOUT_PAYMENT_ERROR',
    PAYMENT_COMPLETE = 'CHECKOUT_PAYMENT_COMPLETE',
    CHECKOUT_COMPLETE = 'CHECKOUT_COMPLETE',
    UNEXPECTED_ERROR = 'CHECKOUT_UNEXPECTED_ERROR',
    FINALIZE_ERROR = 'CHECKOUT_FINALIZE_ERROR',
    WARRANTY_COMPLETE = 'CHECKOUT_WARRANTY_COMPLETE',
    CALC_RESPONSE_INVALID = 'CHECKOUT_CALC_RESPONSE_INVALID',
    CALC_RESPONSE_RETRIED = 'CHECKOUT_CALC_RESPONSE_RETRIED',
    CALC_RESPONSE_RETRY_STATUS = 'CHECKOUT_CALC_RESPONSE_RETRY_STATUS',
}

export enum DataLayerTurnstileEventType {
    TURNSTILE_RENDERED = 'TURNSTILE_RENDERED',
    TURNSTILE_SUCCESS = 'TURNSTILE_SUCCESS',
    TURNSTILE_ERROR = 'TURNSTILE_ERROR',
    TURNSTILE_TIMEOUT = 'TURNSTILE_TIMEOUT',
    TURNSTILE_EXPIRED = 'TURNSTILE_EXPIRED',
}

export enum DataLayerSellFormEventType {
    SHOW_MORE_RESULTS = 'SELL_FORM_SHOW_MORE_RESULTS',
}

export enum DataLayerReturnsEventType {
    START_RETURN = 'START_RETURN',
    CONTINUE_INTERCOM = 'CONTINUE_INTERCOM',
}

export enum DataLayerRiskifiedEventType {
    BEACON_TRIGGERED_ON_PAGE_LOAD = 'BEACON_TRIGGERED_ON_PAGE_LOAD',
}

export const DataLayerReturnsEventGroup = 'RETURN';
